"use client"

import * as React from "react"
import { cn } from "@/lib/utils"

const Loading = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<"div"> & { isLoading?: boolean }
>(({ className, isLoading = true, ...props }, ref) => {
  const [progress, setProgress] = React.useState(0)

  React.useEffect(() => {
    let interval: NodeJS.Timeout

    if (isLoading) {
      setProgress(0)
      interval = setInterval(() => {
        setProgress(prevProgress => {
          if (prevProgress >= 90) {
            clearInterval(interval)
            return prevProgress
          }
          return prevProgress + 10
        })
      }, 500)
    } else {
      setProgress(100)
      setTimeout(() => setProgress(0), 500) // Reset after animation completes
    }

    return () => clearInterval(interval)
  }, [isLoading])

  return (
    <div
      ref={ref}
      className={cn(
        "fixed top-0 left-0 w-full h-1 z-50",
        className
      )}
      {...props}
    >
      <div
        className={cn(
          "h-full bg-blue-500 transition-all duration-500 ease-out",
          progress === 100 ? "transition-none" : ""
        )}
        style={{ width: `${progress}%` }}
      />
    </div>
  )
})

Loading.displayName = "Loading"

export { Loading }